import React, { useState } from 'react';

import LandingFooterCTA from 'common/LandingFooterCTA';
import LandingLogos from 'common/LandingLogos';
import styles from 'css-module/components/www/_PricingV4.module.scss';

import PricingV4CaseStudies from './PricingV4CaseStudies';
import PricingV4Discounts from './PricingV4Discounts';
import PricingV4FAQs from './PricingV4FAQs';
import PricingV4Grid from './PricingV4Grid';
import PricingV4Header from './PricingV4Header';
import PricingV4PlanCards from './PricingV4PlanCards';
import PricingV4Slider from './PricingV4Slider';

import type { Timeframe } from './Timeframe';

const PricingV4 = () => {
  const [timeframe, setTimeframe] = useState<Timeframe>('yearly');
  const [trackedUsers, setTrackedUsers] = useState(25);
  return (
    <div className={styles.pricingV4}>
      <PricingV4Header timeframe={timeframe} setTimeframe={setTimeframe} />
      <PricingV4PlanCards timeframe={timeframe} trackedUsers={trackedUsers} />
      <PricingV4Slider
        timeframe={timeframe}
        trackedUsers={trackedUsers}
        setTrackedUsers={setTrackedUsers}
      />
      <LandingLogos />
      <PricingV4Grid timeframe={timeframe} trackedUsers={trackedUsers} />
      <PricingV4Discounts />
      <PricingV4FAQs />
      <LandingLogos />
      <PricingV4CaseStudies />
      <LandingFooterCTA style="solid" />
    </div>
  );
};

export default PricingV4;
